import React from 'react';
import { Empty } from 'antd';
import { SharedSHSIndividualReport } from './templates/SharedSHSIndividualReport';
import { resolveSHSConfig } from './reportConfigResolver';

export function SHSIndividualReport(props) {
   const config = resolveSHSConfig(props.template, props.subject_id);

   if (!config) {
      return <Empty description='Report not yet available.' image="../images/brainee_mascot.png" />;
   }

   return <SharedSHSIndividualReport {...props} config={config} />;
}
